import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { AboutUs } from './pages/AboutUs';
import { Services } from './pages/Services';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { Refund } from './pages/Refund';
import { Cancellation } from './pages/Cancellation';
import { Contact } from './pages/Contact';
export function AppRouter() {
  return <BrowserRouter data-id="element-12">
      <Routes data-id="element-13">
        <Route path="/" element={<App data-id="element-15" />} data-id="element-14" />
        <Route path="/repair-services" element={<Services data-id="element-17" />} data-id="element-16" />
        <Route path="/about" element={<AboutUs data-id="element-19" />} data-id="element-18" />
        <Route path="/contact" element={<Contact data-id="element-21" />} data-id="element-20" />
        <Route path="/faqs" element={<App data-id="element-23" />} data-id="element-22" />
        <Route path="/terms" element={<Terms data-id="element-25" />} data-id="element-24" />
        <Route path="/privacy" element={<Privacy data-id="element-27" />} data-id="element-26" />
        <Route path="/refund" element={<Refund data-id="element-29" />} data-id="element-28" />
        <Route path="/cancellation" element={<Cancellation data-id="element-31" />} data-id="element-30" />
      </Routes>
    </BrowserRouter>;
}